const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Military extends Technology {
    constructor(age, techName, scienceCost, militaryBonus, militaryActions){
        super(
            age,
            Military.GetType(),
            techName,
            scienceCost,
            null,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.militaryCalculationDelegate.push({
                            Source: this,
                            Action: () => militaryBonus,
                        });
                        playerState.militaryActionCalculationDelegate.push({
                            Source: this,
                            Action: () => militaryActions,
                        });
                    }
            }
        )
    }
    static GetType = () => TechnologyTypes.Special.Military;
}

class Warfare extends Military {
    constructor(){
        super(Warfare.GetAge(), Warfare.GetName(), 5, 1, 1)
    }

    static GetInstance = () => new Warfare();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Special.Warfare;
}

class Strategy extends Military {
    constructor(){
        super(Strategy.GetAge(), Strategy.GetName(), 8, 3, 2)
    }

    static GetInstance = () => new Strategy();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Special.Strategy;
}

class MilitaryTheory extends Military {
    constructor(){
        super(MilitaryTheory.GetAge(), MilitaryTheory.GetName(), 11, 5, 3)
    }

    static GetInstance = () => new MilitaryTheory();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Special.MilitaryTheory;
}

module.exports = {
    Warfare,
    Strategy,
    MilitaryTheory
}